<template>
  <div class="pd-4">
    <b-loading :is-full-page="true" :active.sync="isLoadingPage"></b-loading>
    <div class="mg-t-30">
      <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li class="is-active cursor" @click="gopath('/profile')"><a >Mentors </a></li>
              <li class="is-active"><a href="#" class="nav-color">View profile </a></li>
            </ul>
        </nav>
    </div>
  <article  class="columns mg-y-5 "  >
    <figure  class="media-left blurcontent column is-2">
      <div class="is-140x140">   
        <div class="profileContent" v-if="typeof val.detailUser[0].profilePic != 'undefined' && val.detailUser[0].profilePic != ''" >
          <img :src="imgPath+val.detailUser[0].profilePic" class="mg-x-auto">
        </div>
        <div v-else class="profileContent">
          <img src="@/assets/user.png" class="mg-x-auto">
        </div>
        <div style="margin:15px 0px 5px 0;">
          <span v-if="val.detailUser[0].amountHourly != null && typeof val.detailUser[0].amountHourly != 'undefined'"><strong>Price</strong>&nbsp;<span v-html="currencySymbol(val.detailUser[0].hourlyRate)">&nbsp;</span>{{val.detailUser[0].amountHourly | comma}}/hour</span>
          <span v-else >Free</span>
        </div> 
          <b-button v-if="user.token && user.userLevel == 0"  @click="checkisuserticket(val)"  type="is-info" class="Filters marginfilter" style="float: inherit;margin-top:10px" id="Filters"  outlined>
            <span class="" >Booking Mentor</span>
         </b-button>
      </div>
    </figure>  
      <div class=" blurcontent column">
        <div class="content" style="position:relative">
          <div class="width_mobile" style="margin-bottom: 33px;">
            <div class="columns  has-text-centered-mobile">
              <div class="column pd-b-0 is-9 is-size-5">
                <strong class="th text-capitalize">{{ val.detailUser[0].name  }} {{ val.detailUser[0].surname  }}</strong>
                <span v-if="val.reviewPoints > 0" class="is-size-6 is-block-mobile " :class="widthMax > 767 ? '':'mg-t-10'"> Rating 
                     <span v-for="(value,key) in 5" :key="key"  class="mg-r-8"><i class="fas fa-star" :class="review.rating >= (key+1) ? 'text-orange' : 'text-grey'"></i></span>({{review.rating | floatNumber}})
                </span> 
                <span v-else class="is-size-7 has-text-grey-light is-block-mobile is-hidden-mobile" :class="widthMax > 767 ? '':'mg-t-10'">
                    No rate yet
                </span>
              </div>
            </div>
            <div class="" v-if="val.detailUser[0].professionTitle != '' && val.detailUser[0].professionTitle != null && typeof val.detailUser[0].professionTitle != 'undefined'">"{{val.detailUser[0].professionTitle}}"</div>
            <div class="columns">
              <div class="column th" v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">
                Living in: <span v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">{{ val.detailUser[0].living }}</span>
              </div>
            </div>
            <div class="columns ">
              <div class="column" v-if="val.detailUser[0].language != null && typeof val.detailUser[0].language != 'undefined' && val.detailUser[0].language.length > 0" >
                <!-- {{ val.detailUser[0].industryExpertise }} ${comma(data.name,index,indexlangage)}--> 
              Talk well in: <span v-for="(data,indexlangage) in val.detailUser[0].language" :key="indexlangage">{{data.name}}<span v-if="indexlangage != val.detailUser[0].language.length-1">, </span></span>
              <!-- {{ val.language}} -->
              </div>
            </div>
          <nav class="level is-mobile">
          <div class="level-left" v-if="typeof val.detailUser[0].social != 'undefined'">
            <b-tooltip v-if="val.detailUser[0].social.facebook && val.detailUser[0].social.facebook != null && typeof val.detailUser[0].social.facebook != 'undefined' && typeof val.detailUser[0].social != 'undefined'" 
              class="info-invest" 
              :label="'https://'+val.detailUser[0].social.facebook" 
              position="is-bottom" 
              type="is-info">
              <a  class="level-item">
                  <div class="circle">
                  <i class="fab fa-facebook-f"></i>
                  </div>
              </a>
            </b-tooltip>
            <b-tooltip v-if="val.detailUser[0].social.linkedin && val.detailUser[0].social.linkedin != null && typeof val.detailUser[0].social.linkedin != 'undefined' && typeof val.detailUser[0].social != 'undefined'" 
              class="info-invest" 
              :label="'https://'+val.detailUser[0].social.linkedin" 
              position="is-bottom" 
              type="is-info">
              <a class="level-item">
                <div class="circle">
                  <i class="fab fa-linkedin-in"></i>
                </div>
              </a>
            </b-tooltip>
            <b-tooltip v-if="val.detailUser[0].social.line && val.detailUser[0].social.line != null && typeof val.detailUser[0].social.line != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  
              class="info-invest" 
              :label="val.detailUser[0].social.line" 
              position="is-bottom" 
              type="is-info">             
              <a class="level-item">
                  <div class="circle">
                  <i class="fab fa-line"></i>
                  </div>
              </a>
            </b-tooltip>
            <b-tooltip v-if="val.detailUser[0].social.skype  && val.detailUser[0].social.skype != null && typeof val.detailUser[0].social.skype != 'undefined' && typeof val.detailUser[0].social != 'undefined'" 
              class="info-invest" 
              :label="val.detailUser[0].social.skype" 
              position="is-bottom" 
              type="is-info">
              <a  class="level-item">
                  <div class="circle">
                  <i class="fab fa-skype"></i>
                  </div>
              </a>
            </b-tooltip>
            <b-tooltip  v-if="val.detailUser[0].social.hangouts && val.detailUser[0].social.hangouts != null && typeof val.detailUser[0].social.hangouts != 'undefined' && typeof val.detailUser[0].social != 'undefined'" 
              class="info-invest" 
              :label="val.detailUser[0].social.hangouts" 
              position="is-bottom" 
              type="is-info">
              <a  class="level-item">
                  <div class="circle">
                  <span>H</span> 
                  </div>
              </a>
            </b-tooltip>
            <b-tooltip v-if="val.detailUser[0].social.zoom && val.detailUser[0].social.zoom != null && typeof val.detailUser[0].social.zoom != 'undefined' && typeof val.detailUser[0].social != 'undefined'"
              class="info-invest" 
              :label="val.detailUser[0].social.zoom" 
              position="is-bottom" 
              type="is-info">
              <a    class="level-item">
                  <div class="circle">
                  <span>Z</span>
                  </div>
              </a>
            </b-tooltip>
          </div>
        </nav>
          </div> 
        </div>
        <div class="contenttext is-block-mobile"> 
          <div v-if="typeof val.detailUser[0].industryInterested != 'undefined' && val.detailUser[0].industryInterested != null &&  val.detailUser[0].industryInterested != ''"> Interested in investing:
            <span v-for="(item,key) in val.detailUser[0].industryInterested" :key="key" class="fontblue" style="display:inline-block;margin:2px 2px">
              {{ `${item.name}` }}<span v-if="key != val.detailUser[0].industryInterested.length-1">, </span>
            </span>
          </div>
          <div v-if="val.detailUser[0].sizeInvestment != null && typeof val.detailUser[0].sizeInvestment != 'undefined'  && val.detailUser[0].sizeInvestment != ''"> Size of investment: 
            <span v-for="(item,indexInvest) in val.detailUser[0].sizeInvestment" :key="indexInvest" class="fontblue" style="display:inline-block;margin:2px 2px">
              {{ `${item.name}`  }}<span v-if="indexInvest != val.detailUser[0].sizeInvestment.length-1">, </span>
            </span>
          </div>  
        </div>
        <hr/>
        <div class="contenttext is-block-mobile"> 
          <div v-if="val.detailUser[0].aboutMe != '' && typeof val.detailUser[0].aboutMe != 'undefined' && val.detailUser[0].aboutMe != null">
            {{val.detailUser[0].aboutMe}}
          </div> 
          <div class="mg-t-40">
            <div v-for="(data,indexIndust) in val.detailUser[0].industryExpertise" class="is-inline-block border-radius-small bg-grey-lighter is-size-7 pd-y-2 pd-x-3 mg-r-20 mg-y-1" :key="indexIndust">
              {{data.name}}
            </div>
          </div>
        </div>
      </div>
  </article>

    <article class="th" style="margin-bottom: 1rem;" v-if="review.review.length > 0">
      <div class="columns is-flex-wrap">
        <div class="column is-12 has-text-centered">
          <h5 class="is-size-4">Reviews</h5>
        </div>
        <div class="column is-flex is-justify-end is-align-center is-12">
          <span class="mg-r-5 is-flex is-justify-end is-align-center">
            Sort by
          </span>
            <b-field >
                <b-select placeholder="Select a character" rounded v-model="sortDec" @change="sortNumber()">
                  <option value="1">Highest overall rating</option>
                  <option value="2">Lowest overall rating</option>
                  <option value="3">Date</option>
                </b-select>
            </b-field>
        </div>
      </div>
      <div v-for="(data,index) in review.review" class="media" :key="index">
        <figure  class="media-left blurcontent column is-2">
          <div class="image is-140x140">   
            <div class="profileContent">
              <div style='position: absolute;top: 20%;' v-if="data.anonymous || data.reviewPic == ''">
                <img src="@/assets/user.png" class="mg-x-auto">
              </div>
              <div style='' v-else>
                <img :src="valPic(data.typeSystem)+data.reviewPic" class="mg-x-auto">
              </div>
            </div>
          </div>
        </figure>  
        <div class="media-content blurcontent column is-10">
          <div class="content" style="position:relative">
            <div class="width_mobile">
              <div class="has-text-centered-mobile">
                  <b>Rate </b> <span v-for="(value,key) in 5" :key="key"  class="mr-2"><i class="fas fa-star" :class="data.rating >= (key+1) ? 'text-orange' : 'text-grey'"></i></span>
                </div>
                <div>
                  <p class="font-weight-bold text-back">{{data.title}}</p>
                </div>
                <div>
                  {{data.detail}}
                </div>
                <div>
                  <p class="font-weight-bold font-16 mt-2 text-back"><i>Review by 
                    <span class="font-weight-normal">
                      <span v-if="data.anonymous">anonymous</span>
                      <span v-else>{{data.reviewByName}}</span>
                      <span v-if="typeof data.createDate != 'null' && data.createDate != ''">
                        ({{covertime(data.createDate)}})
                      </span>
                    </span>
                    </i>
                  </p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    </div>
</template>
<script>
import moment from "moment";
import {HTTPReview} from '@/axios.js'
export default {
  watch:{
    sortDec(){
      this.sortNumber() 
    }
  },
  data(){
    return {
      widthMax: window.innerWidth,
      sortDec:3,
      isLoadingPage:true,
      urlTicket:process.env.VUE_APP_BASEURL_TICKET,
      imgPath:process.env.VUE_APP_IMG_PROFILE,
      radio:'',
      isComponentModalActive:false,
      mock_profile:[{
        name:'Chaiyawat Sakulraksakunchai, (Ball)',
        jobs:'(Profession title)penatibus et magnis dis parturient montes nascetur ridiculus mus mauris.',
        address:'Bangkok, Thailand',
        description:`eu scelerisque felis imperdiet proin fermentum leo vel orci porta non pulvinar neque laoreet suspendisse interdum consectetur ty guipg ertnmk
        libero id faucibus nisl tincid eget nullam non nisi est sit amet facilisis magna etiam tempor orci eu lobortis elementum nibh tellus molestie nunc 
        non blandit nunc mattis enim ut tellus elementum. `,
        price:`$50/hour`,
        language:`English, Thai`,
        telephone:`+66 89 456 1234`,
        email:`chaiyawat@gmail.com`,
        website:`www.chaiyawat.com`,
        blur:false,
      }],
      review:'',
      val:this.$store.state.viewprofile
    }
  },
  methods:{
    valPic(type){
      let path = ''
      if(type == 'mentor'){
        path = process.env.VUE_APP_IMG_PROFILE
      }else if(type == 'inteGreat'){
        path = process.env.VUE_APP_IMG_PROFILE_INTEGREAT
      }
      return path
    },
    checkisuserticket(value){
      console.log(value)
      let text = JSON.stringify(this.user.detailUser[0])
      let objSend = JSON.parse(text)
      objSend['userLevel'] = this.user.userLevel
      objSend['userIdExport'] = this.user.typeSystem == 'inteGreat' ? this.user.detailUser[0].userIdExport : this.user.userId
      objSend['typeSystem'] = this.user.typeSystem
      objSend['projectCode'] = 'oZcIppU-VBIx9KO'
      if(value != ''){
        let mentorDetail = {
          mentorId:value.userId,
          userLevel:value.userLevel,
          ...value
        }
        objSend['mentorDetail'] = mentorDetail
      }
      console.log('objSend',objSend)
      var jwt = require('jsonwebtoken');
      var secret = 'dFvsdd125ssE'
      var token = jwt.sign({ 
        token:this.user.token,
        obj:objSend
       }, secret);
      window.open(this.urlTicket+'token/'+token, '_blank');
    },
    currencySymbol(val){
      let data = this.currency.filter(search =>{
        return search.code == val
      })
      return data[0].symbol
    },
    gopath(val){
      this.$router.push(val)
    },
    sortNumber(){
      this.review.review.sort((a, b) => {
        if(this.sortDec == 1){
          const modifier = -1;
          if (Number(a.rating) < Number(b.rating)) return -1 * modifier;
          if (Number(a.rating) > Number(b.rating)) return 1 * modifier;
          return 0;
        }else if(this.sortDec == 2){
          const modifier = 1;
          if (Number(a.rating) < Number(b.rating)) return -1 * modifier;
          if (Number(a.rating) > Number(b.rating)) return 1 * modifier;
          return 0;
        }else{
          const modifier = -1;
          if (a.createDate < b.createDate) return -1 * modifier;
          if (a.createDate > b.createDate) return 1 * modifier;
          return 0;
        }
      });
    },
    covertime(value){
      if (value) {
        var t = moment(value).format("DD MMMM YYYY h:mm a")
        return t;
      }
    },
    fetchComment(){
      let data = {
        ticket:"",
        reviewTo:this.val.userId
      }
      HTTPReview.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
      HTTPReview.post('/api/get/review',data).then(res =>{
        console.log('/api/get/review',res)
        if(res.data.success ){
          res.data.obj.review.sort((a, b) => {
              const modifier = -1;
              if (a.createDate < b.createDate) return -1 * modifier;
              if (a.createDate > b.createDate) return 1 * modifier;
              return 0;
          });
          this.review = res.data.obj
        }
      })  
    },
     bookingmentor(val){
         var data = {
           step:1,
           time:"",
         }
        this.$store.commit('stepbooking',1)
        this.$store.commit('mentoridprofile',val.userId)
         this.isComponentModalActive = true
        // return
        // this.$router.push('booking/mentor')
      },
  },
  created(){
    this.fetchComment()
    setTimeout(()=>{
      this.isLoadingPage = false
    },500)
  },
  computed:{
     user(){
      return this.$store.state.islogin
     },
    currency(){
      return this.$store.state.currency
    },
  },mounted(){
    console.log(this.val)
  }
};
</script>
<style scoped>
article{

}
.profileContent{
    margin: 0 auto;
    width: 140px;
    height: 140px;
    overflow: hidden;
    border-radius: 50%;
    background: #ebebeb;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 5px 5px 0px rgba(237,237,237,1);
}

#Filters.Filters{
  right: 1px;
  display:block;
  padding: 0 2rem;
  border:none;
  background: transparent;
  border-radius: 40px;
  border: 1px solid #0D6ACA !important;
  
}
#Filters.activefilter{
  border: 1px solid #0D6ACA !important;
  background: transparent !important;
}

#Filters.activefilter span,#Filters.activefilter i{
  color: #0D6ACA !important;
}

#Filters .white{
  color:white;
}

#Filters:hover{
  color: #fff;
  /* border: 1px solid #0D6ACA !important; */
  border: 0px solid  !important; 
  background: linear-gradient(180deg, #0D6ACA 0%,#0FB4F1 100%); 
}

.circle span {
    color: white;
    font-weight: bold;
}
.blurbutton{
      padding: 5px 2rem;
    filter: blur(0px);
    position: absolute;
    z-index: 99;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
    border-radius: 40px;
}

.button.is-info.is-outlined:hover, .button.is-info.is-outlined:focus,.button.is-info{
  border-radius: 21px;
    border-color: #0D6ACA;
    color: #0D6ACA;
    background: white;
}

.orangebutton:hover,.orangebutton:focus,.orangebutton{
   border-radius: 21px !important;
    border-color: #FD7900 !important;
    color: #FD7900 !important;
    background: white !important;
}
.b-radio.radio input[type=radio] + .check{
  border: 2px solid #DADADA !important;
  /* border-color: #DADADA; */
}
.media-left{
  text-align: center;
}
.media-content{
  position: relative;
}

.level-item{
  margin-right: 0.6rem;
}
.social i{
  color:white;
  justify-content: center;
  
}
.circle{
    border-radius: 50%;
    background: #0FB9F4;
    text-align: center;
    width: 30px;
    font-size: 13px;
    height: 30px;
    display: flex;
    position: relative;
        justify-content: center;
    align-items: center;
    color:#fff;
}
.circle span{
  color:white;
  font-weight: bold;
}
.circle:hover span{
  color:#0FB9F4;
  font-weight: bold;
}
.circle:hover{
  
  background: white;
  box-shadow: 0 0 0 1px #0FB9F4;
}
.circle:hover i{
   color: #0FB9F4;
}
article{
  margin:0;
  border:1px solid #ebebeb;
  border-radius: 5px;
  background: white;
  padding: 1.8rem;
  position: relative;
  top: 23px;
}
.underline{
  position: absolute;
  bottom: -20px;
  width: 100%;
  background: rgba(0,0,0,0.25);
  height: 1px;
}
.mb{
  margin-bottom: 5rem !important;
}
.blurprofile .blurcontent{
   filter: blur(3px);
   opacity: 0.5;
}

.marginfilter{
    margin: 5px auto;
}

@media only screen and (max-width: 375px) {
  .media{
    display: block;
  }
  article{
    padding:15px;
    /* top: 0px; */
  }
  .media-content{
    width: 100% !important;
  }
  #Filters.Filters{
    margin: 0 auto;
    float: initial;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 768px){
.is-block-mobile {
    display: block !important;
}
}
</style>
<style>
.blurprofile button:hover{
  background: white  !important;
  box-shadow: 0 0 0 1px #FD7900 !important;
  color: #FD7900 !important;
}

</style>